import React, { useState, useEffect } from "react";
import classes from "./styles/style.module.css";
import { useNavigate, useParams } from "react-router";
import appApi from "../../../assets/utils/AppApi";
import errorHandler from "../../../assets/utils/ErrorHandler";
import { motion } from "framer-motion";

const itemContainer = {
  hidden: { y: 20, opacity: 0 },
  visible: {
    y: 0,
    opacity: 1,
  },
};

export default function QuestionMenuElement({
  type,
  typeText,
  bgColor,
  src,
  score,
}) {
  const navigate = useNavigate();
  const { matchId } = useParams();
  const [totalQuestons, setTotalQuestions] = useState(0);
  const [loading, setLoading] = useState(false);
  const ticketId = localStorage.getItem("Ticket");

  const getQuestionType = (query) => {
    let type = "تستی";
    if (query === "multipleImageChoice") {
      type = "تصویری";
    } else if (query === "sorting") {
      type = "مرتب کردن";
    } else if (query === "range") {
      type = "طیفی";
    } else if (query === "difference") {
      type = "کشف تفاوت";
    } else if (query === "puzzle") {
      type = "پازل";
    } else if (query === "connecting") {
      type = "وصل کردن";
    } else if (query === "file") {
      type = "ارسال فایل";
    }
    return type;
  };

  useEffect(() => {
    if (type) {
      getQuestionsCount();
    } else {
      getExposedQuestionsCount();
    }
    return () => {
      setTotalQuestions(0);
    };
  }, []);

  async function getQuestionsCount() {
    try {
      await appApi
        .post(`/quizQuestion/getNumberOfQuestionType`, {
          type: type,
          quizId: matchId,
        })
        .then(({ data }) => {
          setTotalQuestions(data.numberOfQuestionType);
        });
    } catch (error) {
      errorHandler(error);
    }
  }

  async function getExposedQuestionsCount() {
    try {
      await appApi
        .post(`/quizQuestion/getNumberOfQuestionType`, {
          exposed: true,
          quizId: matchId,
        })
        .then(({ data }) => {
          setTotalQuestions(data.numberOfQuestionType);
        });
    } catch (error) {
      errorHandler(error);
    }
  }

  let colorClass = classes.blueBg;
  if (bgColor === "blue") {
    colorClass = classes.blueBg;
  } else if (bgColor === "pink") {
    colorClass = classes.pinkBg;
  } else if (bgColor === "lightBlue") {
    colorClass = classes.lightBlue;
  } else {
    colorClass = classes.purpleBg;
  }

  async function fetchQuestionId() {
    setLoading(true);
    appApi
      .post("/quizQuestion/getSpecificTypeQuestion", {
        type: type,
        ticketId: ticketId,
      })
      .then(({ data }) => {
        const searchParams = new URLSearchParams();
        searchParams.set("type", typeText);
        searchParams.set("qId", matchId);
        navigate(`/question/${data.question._id}?${searchParams.toString()}`);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        errorHandler(error);
      });
  }

  async function fetchExposedQuestionId() {
    setLoading(true);
    appApi
      .post("/quizQuestion/getSpecificTypeQuestion", {
        exposed: true,
        ticketId: ticketId,
      })
      .then(({ data }) => {
        const searchParams = new URLSearchParams();
        searchParams.set("type", getQuestionType(data.question.type));
        searchParams.set("qId", matchId);
        navigate(`/question/${data.question._id}?${searchParams.toString()}`);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        errorHandler(error);
      });
  }

  const handleClickMenuElement = () => {
    if (totalQuestons === 0) {
      return;
    }
    if (loading) {
      return;
    } else {
      if (type) {
        fetchQuestionId();
      } else {
        fetchExposedQuestionId();
      }
    }
  };

  const menuElementClasses = [classes.quesitonMenuElement, colorClass];
  if (totalQuestons === 0) {
    menuElementClasses.push(classes.disabled);
  }

  return (
    <motion.div
      variants={itemContainer}
      className={menuElementClasses.join(" ")}
      onClick={handleClickMenuElement}
    >
      <img src={src} alt={typeText} />
      <div className={classes.typeTextContainer}>
        <p>{`${typeText} (${totalQuestons})`}</p>
        <p>{`${score} امتیازی`}</p>
      </div>
    </motion.div>
  );
}
